import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonLibModule } from '@nrwl/common-lib';
import { AtwebQueryModule } from '@nrwl/at-web-query';
import { QueryEmitterModule } from '@nrwl/query-emitter';
import { CommonMaterialModule } from '@nrwl/common-material';
import { SmartSearchModule } from '@nrwl/smart-search';
import { SmartSearchBaseComponent } from './components/smart.search.base/smart.search.base.component';
import { ChipExpressionEventProvider } from './components/smart.search.base/chip.expression.event.provider';
import { DrillEventsHandler } from './components/smart.search.base/drill.events.handler';

@NgModule({
  imports: [
    CommonModule,
    CommonLibModule,
    CommonMaterialModule,
    SmartSearchModule,
    AtwebQueryModule,
    QueryEmitterModule
  ],
  declarations: [SmartSearchBaseComponent],
  providers: [ChipExpressionEventProvider, DrillEventsHandler],
  exports: [SmartSearchBaseComponent]
})
export class SmartSearchBaseModule {}
